<div class="guts-p-t-2">
  @if (!hasNoFilter) {
    <dgx-sticky-filter-bar>
      <div class="l_flexbar m-l_flexbar-block tw-w-full lg:tw-w-auto">
        <div class="guts-p-r-1 m-no-guts" data-dgat="orgReporting-645">
          <ng-container
            *ngComponentOutlet="
              getComponent('dgxReportingRangePicker');
              inputs: getChartInputs('dgxReportingRangePicker')
            "
          ></ng-container>
        </div>
        @if (context === 'channel') {
          <div class="m-guts-m-t-half">
            <div
              class="form__label ib"
              [innerHTML]="i18n.Core_Organizations"
            ></div>
            <dgx-combobox
              class="guts-p-l-half ib m-full-width"
              [ariaLabel]="i18n.OrgReportingCtrl_FilterByOrg"
              [isExactMatchesEnabled]="false"
              [selectedOption]="$safeNavigationMigration(selectedOrg?.name)"
              [options]="tenants"
              [placeholder]="i18n.OrgReportingCtrl_FilterByOrg"
              (selection)="onOrgSelection($event)"
              [hasNoResultsText]="i18n.OrgReportingCtrl_NoMatchingOrgs"
              labelKey="name"
              trackBy="organizationId"
              dgatInput="org-reporting-2ec"
            >
            </dgx-combobox>
          </div>
        }
        @if (initComplete && groupOptions && context !== 'channel') {
          <div class="m-guts-m-t-half">
            <dgx-combobox
              class="m-full-width"
              [ariaLabel]="i18n.OrgReportingCtrl_FilterByGroup"
              [isExactMatchesEnabled]="true"
              [isMultiSelect]="true"
              [isFixedWidth]="true"
              [options]="groupOptions"
              [placeholder]="i18n.OrgReportingCtrl_FilterByGroup"
              (selections)="onGroupSelections($event)"
              [hasNoResultsText]="i18n.OrgReportingCtrl_NoMatchingGroups"
              labelKey="name"
              trackBy="groupId"
              (click)="trackInsightFilter('Group', $event)"
              data-dgat="orgReporting-c05"
              dgatInput="org-reporting-15d"
            >
              <dgx-user-count-warning-message
                [warningMessage]="warningMessage"
                message
              ></dgx-user-count-warning-message>
            </dgx-combobox>
          </div>
        }
      </div>
      @if (permissions.canDownloadReports && context !== 'channel') {
        <div
          class="l_flex--align-right l_flex--align-right--no-mobile guts-p-l-2 m-block m-guts-p-l-0 m-guts-p-t-half tw-w-full lg:tw-w-auto"
        >
          <a
            [routerLink]="['/orgs', orgId, 'downloadableReports']"
            [queryParams]="typedReportingParams"
            class="m-full-width tw-btn-medium tw-btn-secondary-outline"
            data-dgat="Organizations-Index-ae5"
          >
            <da-icon
              icon="arrow-down-tray"
              type="solid-small"
              class="guts-m-r-half tw-reset tw-inline-block tw-align-middle"
            ></da-icon>
            {{ i18n.OrgReportingCtrl_DownloadableReports }}
          </a>
        </div>
      }
    </dgx-sticky-filter-bar>
  }
  @if (!showMore) {
    <section class="guts-p-t-1">
      <dgx-kpi-list
        class="guts-p-t-3"
        [kpiClass]="'grid__col-sm-3'"
        [kpis]="kpis"
        [kpisLoading]="kpisLoading"
        [kpisError]="kpisError"
        [kpiPlaceholder]="[0, 0, 0, 0]"
      ></dgx-kpi-list>
    </section>
  }
  <div [ngClass]="{ 'guts-p-b-3': showMore }">
    @if (!showMore && permissions.enableActiveUserInsights) {
      <div>
        <section class="grid__col-12">
          <div
            class="grid__cell box-shadow rounded--large guts-p-full-2 m-guts-p-full-1"
          >
            <ng-container
              *ngComponentOutlet="
                getComponent('dgxActiveUserChart');
                inputs: getChartInputs('dgxActiveUserChart')
              "
            ></ng-container>
          </div>
        </section>
      </div>
    }
    @if (!showMore) {
      <div>
        <section class="grid__col-12">
          <div
            class="grid__cell box-shadow rounded--large guts-p-full-2 m-guts-p-full-1"
          >
            <ng-container
              *ngComponentOutlet="
                getComponent('dgxLearningChart');
                inputs: getChartInputs('dgxLearningChart')
              "
            ></ng-container>
          </div>
        </section>
      </div>
    }
    @if (
      (!showMore || showMore === 'skillRatings') &&
      context === 'channel' &&
      orgId
    ) {
      <div>
        <section class="grid__col-12">
          <div
            class="grid__cell"
            [ngClass]="{
              'box-shadow rounded--large guts-p-full-2 m-guts-p-full-1':
                !showMore,
            }"
          >
            <ng-container
              *ngComponentOutlet="
                getComponent('dgxSkillRatingsChart');
                inputs: getChartInputs('dgxSkillRatingsChart')
              "
            ></ng-container>
          </div>
        </section>
      </div>
    }
    <div [ngClass]="{ grid: !showMore }">
      <div class="grid__col-12 grid__col-sm-6">
        @if (!showMore || showMore === 'popularProviders') {
          <section
            [ngClass]="{
              'l_flex-grow-vertical box-shadow rounded--large guts-p-full-2 m-guts-p-full-1':
                !showMore,
            }"
          >
            <ng-container
              *ngComponentOutlet="
                getComponent('dgxTopCompletionsChart');
                inputs: getChartInputs('dgxTopCompletionsChart')
              "
            ></ng-container>
          </section>
        }
      </div>
      <div class="grid__col-12 grid__col-sm-6">
        @if (!showMore || showMore === 'popularData') {
          <section
            [ngClass]="{
              'l_flex-grow-vertical box-shadow rounded--large guts-p-full-2 m-guts-p-full-1':
                !showMore,
            }"
          >
            <ng-container
              *ngComponentOutlet="
                getComponent('dgxPopularDataChart');
                inputs: getChartInputs('dgxPopularDataChart')
              "
            ></ng-container>
          </section>
        }
      </div>
    </div>
    @if (hasTopGroups) {
      <div>
        <section class="grid__col-12">
          <div
            class="grid__cell"
            [ngClass]="{
              'box-shadow rounded--large guts-p-full-2 m-guts-p-full-1':
                !showMore,
            }"
          >
            <dgx-top-groups
              [orgId]="orgId"
              [startDate]="startDate.value"
              [endDate]="endDate.value"
              [context]="context"
              [location]="'Org Insights'"
            >
            </dgx-top-groups>
          </div>
        </section>
      </div>
    }
    @if (hasRecommendationsStatus) {
      <div>
        <section class="grid__col-sm-12 guts-m-b-2">
          <div
            class="grid__cell"
            [ngClass]="{
              'box-shadow rounded--large guts-p-full-2 m-guts-p-full-1':
                !showMore,
            }"
          >
            <dgx-recommendations-status
              [orgId]="orgId"
              [groupId]="groupIdList"
              [location]="'Org Insights'"
            >
            </dgx-recommendations-status>
          </div>
        </section>
      </div>
    }
  </div>
  @if (!showMore) {
    <div class="footer-glasses"></div>
  }
</div>
